import { useState } from "react";
import { syncApiUrl } from "@cliqsuite/db";
import { AuthHead, IconField } from "./AuthFrame";

/**
 * One of LoginScreen's modes, reached from "Forgot password?". Always ends on the same
 * "check your email" message, whether or not the address has an account (no enumeration).
 */
export function ForgotPasswordPage({ onBackToLogin }: { onBackToLogin: () => void }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(syncApiUrl("/auth/forgot-password"), {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email }),
      });
    } catch {
      // A network error shows the same message as an unknown email.
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  if (sent) {
    return (
      <div className="o-auth__form">
        <AuthHead icon="mark_email_read" tone="ok" title="Check your email" sub={`If ${email} has an account, a link to reset your password is on its way.`} />
        <button type="button" className="o-auth__submit" onClick={onBackToLogin}>
          Back to sign in
        </button>
      </div>
    );
  }

  return (
    <form className="o-auth__form" onSubmit={submit}>
      <AuthHead icon="key" title="Reset your password" sub="We'll email you a link to set a new one." />
      <IconField label="Email" icon="mail" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.com" required />
      <button type="submit" className="o-auth__submit" disabled={loading}>
        {loading ? "Sending…" : "Send reset link"}
        {!loading && <span className="ms" aria-hidden="true">arrow_forward</span>}
      </button>
      <button type="button" className="o-link o-auth__alt" onClick={onBackToLogin}>
        Back to sign in
      </button>
    </form>
  );
}
